import { render, staticRenderFns } from "./AppellantRightToAppealJourneyMap.vue?vue&type=template&id=6119615f&scoped=true"
import script from "./AppellantRightToAppealJourneyMap.vue?vue&type=script&lang=ts"
export * from "./AppellantRightToAppealJourneyMap.vue?vue&type=script&lang=ts"
import style0 from "./AppellantRightToAppealJourneyMap.vue?vue&type=style&index=0&id=6119615f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6119615f",
  null
  
)

export default component.exports